/**
 * Central source of truth for policy versions.
 *
 * Bump the ISO date when a policy is materially updated. `POLICY_LAST_UPDATED_LABEL`
 * is what's shown to customers on the policy pages. The API mirrors these values
 * via `GET /api/policies/versions` so checkout can record which version applied
 * to each order.
 *
 * Non-material formatting corrections should NOT bump the version — that would
 * force every future order to record a "new" acceptance for cosmetic changes.
 */
export const POLICY_VERSIONS = {
  terms: "2026-09-18",
  privacy: "2026-09-18",
  rewards: "2026-09-18",
  refund: "2026-09-18",
};

export const POLICY_LAST_UPDATED_LABEL = "18 September 2026";
export const SUPPORT_EMAIL = "arthursvault00@gmail.com";
